import LoadPattern from "./LoadPattern";

export default LoadPattern;
